export default {
  /** @type {(el: Element) => void} */
  inserted: function (el) {
    if (el.nodeName !== 'INPUT') el = el.querySelector('input');
    el.focus();
  }
};
